import { useCurrentUserContext } from '@openclassrooms/data-connect-web/users';

import Error403 from '../screens/Error403';
import Error404 from '../screens/Error404';
import Error500 from '../screens/Error500';
import GenericError from '../screens/GenericError';

import RedirectToSignin from './RedirectToSignin';

function Errors({ globalError }) {
  const { isConnected } = useCurrentUserContext();

  switch (globalError?.statusCode) {
    case 401:
      return <RedirectToSignin />;
    case 403:
      return isConnected ? <Error403 /> : <RedirectToSignin />;
    case 404:
    case 410:
      return <Error404 />;
    case 500:
      return <Error500 />;
    default:
      return <GenericError />;
  }
}

export default Errors;
